export const genders = {
  MALE: "Masculin",
  FEMALE: "Féminin",
  AGENDER: "Agenre",
  NON_BINARY: "Non Binaire",
  QUEER: "Queer",
};

export const gendersEn = {
  MALE: "Male",
  FEMALE: "Female",
  AGENDER: "Agender",
  NON_BINARY: "Non Binary",
  QUEER: "Queer",
};
